const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/dashboard/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/dashboard/')({
  beforeLoad: async ({
    context: {
      flags
    },
    params
  }) => {
    if (!flags.loopSidebar) {
      throw redirect({
        to: '/org/$org',
        params: {
          org: params.org
        }
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});